import React from 'react';
import styled from 'styled-components';
import LogItem from 'modules/emergencies/components/log/LogItem';
import LogHeader from 'modules/emergencies/components/log/logComponents/Header';
import LogsItemContainer from 'modules/emergencies/components/ui/containers/logsItemContainer';

const LogsList = ({ className, logs = [], onNewComment, ticketId = null }) => {
  return (
    <div className={className}>
      <LogHeader label={'logs'} ticketId={ticketId} onNewComment={onNewComment} />
      <LogsItemContainer>
        {logs.map((log, i) => (
          <LogItem key={`log-${i}`} log={log} />
        ))}
      </LogsItemContainer>
    </div>
  );
};

export default styled(LogsList)`
  position: sticky;
  top: 0;
  width: 420px;
  background-color: var(--primary-background);
  border-left: 1px solid var(--accent-color-gray);
  display: flex;
  flex-direction: column;
`;
